export default __webpack_public_path__ + "static/media/billings-not-selected_skyblue.b81ebae7.svg";